import { AFFILIATE_DASHBOARD_API } from 'modules/affiliate-dashboard/api/affiliate-dashboard-api'
import { AffiliateDashboardFilterInterface } from 'modules/affiliate-dashboard/types/affiliate-dashboard-interface'
import { AffiliateDashboardInvoicesApiInterface } from 'modules/affiliate-dashboard/types/affiliate-dashboard-invoices-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import { CountInterface, SwrPaginationInterface } from 'shared/types/pagination-interface'
import { getFilterQueryString } from 'shared/utils/api/get-filter-query-string'
import { getPaginationAndFilterQueryString } from 'shared/utils/api/get-pagination-and-filter-query-string'
import { baseFetcher } from 'shared/utils/http-client'
import useSWR from 'swr'

interface UseAffiliateDashboardInvoicesInterface extends SwrPaginationInterface {
  filter: AffiliateDashboardFilterInterface
}

export const useAffiliateDashboardInvoices = ({
  filter,
  limit,
  pagination,
}: UseAffiliateDashboardInvoicesInterface) => {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, AffiliateDashboardInvoicesApiInterface>({
    method: RequestMethodsEnum.get,
  })

  const invoicesFilter = {
    dateSince: filter.dateSince,
    dateTill: filter.dateTill,
  }

  const { data: affiliateInvoices } = useSWR(() => {
    if (!user || filter.dateSince === null) return
    return `${AFFILIATE_DASHBOARD_API}/invoices/list${
      filter.vendorId ? `/${filter.vendorId}` : ''
    }?${getPaginationAndFilterQueryString({
      limit,
      pagination,
      filter: invoicesFilter,
    })}`
  }, fetcher)

  const { data: counter } = useSWR<CountInterface>(() => {
    if (!user || filter.dateSince === null) return

    return `${AFFILIATE_DASHBOARD_API}/invoices/count${
      filter.vendorId ? `/${filter.vendorId}` : ''
    }?${getFilterQueryString({
      filter: invoicesFilter,
    })}`
  }, baseFetcher)

  return { affiliateInvoices, counter }
}
